export const domain = 'AppStatus';

// action types
export const DESTROY_APP_STATUSES = `${domain}/DESTROY_APP_STATUSES`;
export const RECEIVE_STATUS = `${domain}/RECEIVE_STATUS`;
export const RECEIVE_NEXT_PROVIDER_ID = `${domain}/RECEIVE_NEXT_PROVIDER_ID`;
export const RECEIVE_NEXT_PROVIDER_NAME = `${domain}/RECEIVE_NEXT_PROVIDER_NAME`;
export const RECEIVE_NEXT_PROVIDER_AUTOSUBMIT = `${domain}/RECEIVE_NEXT_PROVIDER_AUTOSUBMIT`;
export const SET_COMPLETED_APP_STATUS_FIELDS = `${domain}/SET_COMPLETED_APP_STATUS_FIELDS`;
